/**
 * The order's requested delivery time of day. It lives in its own
 * `deliveryDetails.time` field — the delivery date's timestamp carries whatever
 * time the order happened to be created at, which is not a delivery time.
 *
 * Extracted verbatim from the order details page (DD-3801) so the Internt tab can
 * read the same field. An hour of 0 renders nothing, as it always has.
 */
export const formatDeliveryTime = (time?: { hour?: number; minute?: number }): string | undefined => {
    if (!time?.hour) return undefined;

    const hour = time.hour <= 9 ? `0${time.hour}` : `${time.hour}`;
    const minute = time.minute ? (time.minute <= 9 ? `0${time.minute}` : `${time.minute}`) : '00';

    return `${hour}:${minute}`;
};
